import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Button, Form} from 'semantic-ui-react';
import {validateErrors, parseFileData} from '../../utils';
import {downloadFile} from '../../../common/util/file';
import {Actions} from '../../../common/actions';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import ExcelReader from '../../../excelReader/components/index';
import MainLoader from '../../../common/components/loader';
import NotificationModal from './modal/NotificationModal';
import ReportModal from './modal/ReportModal';
import CampaignInfo from './CampaignInfo';
import TablesCampaign from './tables';
import './styles.scss';

const initialState = {
  'campaingNo': null,
  'campaingName': '',
  'createDate': '',
  'dateCreation': '',
  'detail': '',
  'sscCode': '',
  'status': 'A',
  'user': '',
};

class EditCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
      'disabledBtns': false,
      'edit': false,
      'title': 'Ingresar',
      'getFirstTime': false,
    };
  }

  componentDidMount() {
    const {campaingNo, isUserTde} = this.props;
    if (!hasAccessPermission(this.props.permissions, resources.MaintainCampaign, scopes.Edit) ||
    !hasAccessPermission(this.props.permissions, resources.MaintainCampaign, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    if (campaingNo) {
      this.props.clearCampaign();
      this.props.getCampaignById(campaingNo);
      this.setState({
        'disabledBtns': !hasAccessPermission(this.props.permissions, resources.MaintainCampaign, scopes.Edit),
        'title': isUserTde ? 'Editar' : 'Ver',
        'edit': true,
        'campaingNo': campaingNo,
        'getFirstTime': true,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {campaign, loading, successCreation, chassisExcelFile} = this.props;
    const {edit, getFirstTime} = this.state;

    if (campaign && edit && (getFirstTime || prevProps.loading !== loading)) {
      this.setState({
        ...campaign,
        'getFirstTime': false,
      });
    }
    if (!edit && successCreation && campaign) {
      this.setState({
        ...campaign,
        'title': 'Editar',
        'edit': true,
        'getFirstTime': false,
      });
      this.props.navigateTo(`/editar-campana/${campaign.campaingNo}`);
    }
    if (chassisExcelFile) {
      downloadFile(chassisExcelFile);
      this.props.clearChassisExcelFile();
    }
  }

  componentWillUnmount() {
    this.props.clearCampaign();
  }

  readExcelFile = (data) => {
    const {campaingNo} = this.state;
    const chassisData = data.slice(1);
    const loadedChassis = parseFileData(chassisData);
    this.props.loadingExcel(false);
    this.props.processCampaignChassis(campaingNo, loadedChassis);
  };

  handleExportClick = () => {
    const {campaingNo} = this.state;
    this.props.downloadCampaignChassisExcel(campaingNo);
  };

  handleChange = (field, value) => {
    this.setState({[field]: value.toUpperCase()});
  };

  handleSubmit = (event) => {
    const {sscCode, campaingName, campaingNo, status, detail, edit} = this.state;
    const {partsArray} = this.props;

    const data = {
      sscCode,
      campaingName,
      status,
      detail,
    };

    const {error, message} = validateErrors(data);
    if (error) {
      this.props.addMessageBoxError(message);
    } else if (edit) {
      const updateData = {...data, campaingNo, partsArray};
      this.props.updateCampaign(updateData);
    } else {
      this.props.addCampaign(data);
    }
    event.preventDefault();
  };

  renderButtons = (isLoading) => {
    const {isUserTde, attachments, rawAttachments, loadingAttachments,
      loadingExcelFile, loadingChassisExcelFile} = this.props;
    const {disabledBtns, edit, campaingNo} = this.state;

    if (isUserTde) {
      return (
        <div className='title-bar-actions'>
          <Button
            disabled={disabledBtns || isLoading}
            color='green'
            onClick={this.handleSubmit}
          >
            {edit ? 'GUARDAR' : 'CREAR'}
          </Button>
          {edit && (
            <>
              <NotificationModal disabled={disabledBtns || isLoading} {...this.state} />
              <ReportModal
                disabled={disabledBtns || isLoading}
                campaingNo={campaingNo}
                isUserTde={isUserTde}
                loadingAttachments={loadingAttachments}
                rawAttachments={rawAttachments}
                attachments={attachments}
              />
              <ExcelReader
                saving={loadingExcelFile}
                onGetFile={this.readExcelFile}
              />
              <Button
                primary
                icon='download'
                content='EXPORTAR'
                loading={loadingChassisExcelFile}
                disabled={isLoading}
                onClick={this.handleExportClick}
              />
            </>
          )}
        </div>
      );
    }

    return (
      <div className='title-bar-actions'>
        <ReportModal
          campaingNo={campaingNo}
          isUserTde={isUserTde}
          loadingAttachments={loadingAttachments}
          rawAttachments={rawAttachments}
          attachments={attachments}
        />
        <Button
          primary
          icon='download'
          content='EXPORTAR'
          loading={loadingChassisExcelFile}
          disabled={isLoading}
          onClick={this.handleExportClick}
        />
      </div>
    );
  }

  render() {
    const {
      loading,
      isUserTde,
      loadingExcelFile,
      loadingChassisArray,
      loadingChassisExcelFile,
    } = this.props;

    const {title, edit, campaingNo} = this.state;
    const isLoading =
      loadingExcelFile || loadingChassisArray || loadingChassisExcelFile;

    if (loading) {
      return <MainLoader />;
    }

    return (
      <div className='campaign-container'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>{title} Campaña</h2>
              {this.renderButtons(isLoading)}
            </div>
          </div>
        </Card>
        <Card raised fluid>
          <div className='campaign-info-container'>
            <Form>
              <Form.Group widths='equal'>
                <CampaignInfo
                  {...this.state}
                  handleChange={this.handleChange}
                />
              </Form.Group>
            </Form>
          </div>
        </Card>

        <TablesCampaign
          isLoading={isLoading}
          edit={edit}
          isUserTde={isUserTde}
          campaingNo={campaingNo}
          loadingExcelFile={loadingExcelFile}
          loadingChassisExcelFile={loadingChassisExcelFile}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'campaingNo': ownProps.params && ownProps.params.id,
    'isUserTde': state.session.isUserFromTDE,
    'permissions': state.session.permissions,
    'loading': state.campaign.loading,
    'campaign': state.campaign.campaign,
    'loadingAttachments': state.campaign.loadingAttachments,
    'rawAttachments': state.campaign.rawAttachments,
    'attachments': state.campaign.attachments,
    'successCreation': state.campaign.successCreation,
    'loadingExcelFile': state.excelReader.loading,
    'loadingChassisArray': state.campaignChassis.loading,
    'loadingChassisExcelFile': state.campaignChassis.loadingChassisExcelFile,
    'chassisExcelFile': state.campaignChassis.chassisExcelFile,
    'partsArray': state.campaignParts.partsArray,
  };
};

const {
  withRouter,
  navigateTo,
  addCampaign,
  loadingExcel,
  clearCampaign,
  updateCampaign,
  getCampaignById,
  addMessageBoxError,
  clearChassisExcelFile,
  processCampaignChassis,
  downloadCampaignChassisExcel,
} = Actions;

const mapDispatchToProps = {
  navigateTo,
  addCampaign,
  loadingExcel,
  clearCampaign,
  updateCampaign,
  getCampaignById,
  addMessageBoxError,
  clearChassisExcelFile,
  processCampaignChassis,
  downloadCampaignChassisExcel,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EditCampaign)
);
